export default {
  SET_UNOMI_CONFIGS: 'setUnomiConfigs',
  SET_SELECTED_UNOMI_CONFIG: 'setSelectedUnomiConfig',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_FIELD_CUSTOMER_PROPERTIES: 'setFieldCustomerProperties',
}